import { render, staticRenderFns } from "./anlidetails.vue?vue&type=template&id=94432130&scoped=true"
import script from "./anlidetails.vue?vue&type=script&lang=js"
export * from "./anlidetails.vue?vue&type=script&lang=js"
import style0 from "./anlidetails.vue?vue&type=style&index=0&id=94432130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94432130",
  null
  
)

export default component.exports